import { apiPost, API_ENDPOINTS } from "../utils/apiUtils";

/**
 * User Service
 * Handles user management, accounts, reports, and contacts
 */
const UserService = {
  // User Management
  /**
   * Get all users
   * @param {Object} filters - Filter parameters
   * @returns {Promise} API response
   */
  async getAllUser(filters) {
    return apiPost(API_ENDPOINTS.USERS.GET_ALL, filters);
  },

  /**
   * Get user details
   * @param {Object} userData - User identifier
   * @returns {Promise} API response
   */
  async getUserDetails(userData) {
    return apiPost(API_ENDPOINTS.USERS.GET_DETAILS, userData);
  },

  /**
   * Update user details (activation)
   * @param {Object} userData - User update data
   * @returns {Promise} API response
   */
  async updateUserDetails(userData) {
    return apiPost(API_ENDPOINTS.USERS.UPDATE, userData);
  },

  /**
   * Upgrade user to pro
   * @param {Object} userData - User upgrade data
   * @returns {Promise} API response
   */
  async updateUserPro(userData) {
    return apiPost(API_ENDPOINTS.USERS.UPGRADE, userData);
  },

  /**
   * Delete user
   * @param {Object} userData - User deletion data
   * @returns {Promise} API response
   */
  async deleteUser(userData) {
    return apiPost(API_ENDPOINTS.USERS.DELETE, userData);
  },

  // Account Management
  /**
   * Get all accounts
   * @param {Object} filters - Filter parameters
   * @returns {Promise} API response
   */
  async getAllAccounts(filters) {
    return apiPost(API_ENDPOINTS.ACCOUNTS.GET_ALL, filters);
  },

  /**
   * Update account details (activation)
   * @param {Object} accountData - Account update data
   * @returns {Promise} API response
   */
  async updateAccountDetails(accountData) {
    return apiPost(API_ENDPOINTS.ACCOUNTS.UPDATE, accountData);
  },

  // Reports
  /**
   * Get reports
   * @param {Object} reportData - Report parameters
   * @returns {Promise} API response
   */
  async getReports(reportData) {
    return apiPost(API_ENDPOINTS.REPORTS.GET_ALL, reportData);
  },

  // Contact Management
  /**
   * Get all contacts
   * @param {Object} filters - Filter parameters
   * @returns {Promise} API response
   */
  async getContacts(filters) {
    return apiPost(API_ENDPOINTS.CONTACTS.GET_ALL, filters);
  },

  /**
   * Delete contact
   * @param {Object} contactData - Contact deletion data
   * @returns {Promise} API response
   */
  async deleteContact(contactData) {
    return apiPost(API_ENDPOINTS.CONTACTS.DELETE, contactData);
  },
};

export default UserService;
